module.exports = {
  ROOT_SHELL_COPY: {
    title: "FractoLabs | AI Digital Employees — Qualify & Book 24/7",
    description:
      "FractoLabs deploys AI digital employees for your business: greet inbound leads, qualify jobs, and book appointments 24/7. Works with your CRM and calendar. Start a free trial.",
    ogTitle: "FractoLabs | AI Digital Employees",
    ogDescription:
      "Industry-trained Digital assistants that qualify leads and fill your calendar 24/7. Plug into your existing CRM and messengers.",
    ogImageAlt: "FractoLabs AI digital employees",
  },
  STUB_SHELL_COPY: {
    title: "Alex S. | Systems & Cloud Infrastructure Architect",
    description:
      "Cloud infrastructure, automated backend pipelines, and data routing systems. Currently fully booked — not accepting new consulting projects.",
    ogTitle: "Alex S. | Systems & Cloud Infrastructure Architect",
    ogDescription: "Currently fully booked and not accepting new consulting projects or clients.",
  },
};
